import api from "../../../utils/api";

// Read list of CI Statuses
export const readCiStatuses = async (params) => {
  const res = await api.get("/cistatuses", params ? { params } : {});
  return res.data;
};
